import { render, staticRenderFns } from "./LawAuthorityList.vue?vue&type=template&id=454f0b00&"
import script from "./LawAuthorityList.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityList.vue?vue&type=style&index=0&id=454f0b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports